// 新建案件彈窗翻譯配置 - 繁體中文
export default {
  dialog: {
    title: "新建案件",
  },
  form: {
    labels: {
      name: "案件名稱",
      caseType: "案件類型",
      description: "案件說明",
    },
    placeholders: {
      name: "請輸入案件名稱(必填)",
      caseType: "請選擇案件類型(必填)",
      description: "請輸入案件說明",
    },
    rules: {
      nameRequired: "案件名稱為必填項",
      nameLength: "長度在 1 到 20個字符",
      caseTypeRequired: "請選擇案件類型",
      descriptionLength: "長度在 1 到 200個字符",
    },
  },
  buttons: {
    cancel: "取消",
    create: "新建",
  },
  messages: {
    createSuccess: "新建成功",
  },
};
